@if (isDebugNotchVisible()) {
    <wh-debugger />
}

<router-outlet />

@if (updateOverlayVisible()) {
    <div class="update-overlay" role="status" aria-live="assertive" aria-busy="true">
        <div class="update-overlay__card">
            <div class="update-overlay__spinner" aria-hidden="true"></div>
            <h2 class="update-overlay__title">{{ updateOverlayTitleKey() | translate }}</h2>
            <p class="update-overlay__text">{{ updateOverlayTextKey() | translate }}</p>
        </div>
    </div>
}

@if (backdropActive()) {
    <wh-backdrop [class.active]="true" (click)="onBackdropClick()"/>
}
